module.exports = __webpack_public_path__ + "img/MAGAZINE UNLOADER (Standard Type).95430b53.jpg";